import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M2 22v-5l5-5 5 5-5 5z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9.5 14.5 16 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Shovel";
const Shovel = memo(themed(Icon));
export {
  Shovel
};
//# sourceMappingURL=shovel.js.map
